export function createEndpoint<TResponse, TError = undefined, TRequest = undefined>(config: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'; // Add other methods as needed
}): {
  url: string;
  method: string;
  params: string[]; // We define params to allow for type checking, but this array is not used in the actual request
  types: {
    response: TResponse;
    request: TRequest extends undefined ? never : TRequest;
    error: TError extends undefined ? never : TError;
  };
} {
  // Extract params from the URL
  const params = config.url.match(/:([a-zA-Z_]+)/g)?.map((param) => param.slice(1)) || [];
  return {
    ...config,
    params,
    types: {
      response: null as unknown as TResponse,
      request: null as unknown as TRequest extends undefined ? never : TRequest,
      error: null as unknown as TError extends undefined ? never : TError,
    },
  };
}

// export function getHeaders(h: any): Headers {
//   const token = localStorage.getItem('nh-token');
//   if (token) {
//     if (!(h instanceof Headers)) {
//       h = new Headers(h);
//     }

//     // Pre-pend 'Bearer' if it is not already present
//     h.set('Authorization', token.startsWith('Bearer ') ? token : `Bearer ${token}`);
//   }

//   return h;
// }
